import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit() {
  }

  /**
   * To close global message popup
   */
  closePopup() {
    this.data.confirmCallBack(false);
    //this.common.toggleGlobalMessagePopupVisibility(false);
  }

  /**
   * To close global message popup
   */
  confirm() {
    this.data.confirmCallBack(false);
    //this.common.toggleGlobalMessagePopupVisibility(false);
  }

}
